import { render } from "./KarirView.vue?vue&type=template&id=182ee49d"
import script from "./KarirView.vue?vue&type=script&lang=js"
export * from "./KarirView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__